import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";
import { CCard } from "../../../components/common/CCard";

function DeliveryTypeSkeleton() {
  return (
    <>
      <CCard
        sx={{
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={3}
          sx={{ width: "100%" }}
        >
          <Skeleton
            variant="rectangular"
            width="20%"
            height="25px"
            sx={{ borderRadius: 1 }}
          />

          <Skeleton
            variant="rectangular"
            width="30%"
            height="25px"
            sx={{ borderRadius: 1 }}
          />
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={3}
          sx={{ width: "100%" }}
        >
          <Skeleton
            variant="rectangular"
            width="25%"
            height="25px"
            sx={{ borderRadius: 1 }}
          />

          <Skeleton
            variant="rectangular"
            width="40%"
            height="25px"
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </CCard>
    </>
  );
}

export default DeliveryTypeSkeleton;
